import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ReconOpportunityEntity } from './recon-opportunity.entity';
import { ReconSocialProfileEntity } from './recon-social-profile.entity';

/**
 * Conversation threads with social prospects.
 * Tracks message history and outcome.
 */
@Entity('recon_conversations')
@Index('idx_recon_conversations_status', ['status'])
@Index('idx_recon_conversations_last_message', ['lastMessageAt'])
export class ReconConversationEntity extends BaseEntity {
	// Links
	@Column('int', { name: 'opportunity_id', unsigned: true, nullable: true })
	public opportunityId!: number | null;

	@Column('int', { name: 'social_profile_id', unsigned: true })
	public socialProfileId!: number;

	@Column('int', { name: 'client_contact_id', unsigned: true, nullable: true })
	public clientContactId!: number | null;

	// Platform
	@Column('varchar', { name: 'platform', length: 50 })
	public platform!: string;

	@Column('varchar', {
		name: 'platform_thread_id',
		length: 500,
		nullable: true,
	})
	public platformThreadId!: string | null;

	// State
	/**
	 * Conversation status.
	 * 'active', 'closed', 'converted'
	 */
	@Column('varchar', { name: 'status', length: 30, default: 'active' })
	public status!: string;

	@Column('datetime', { name: 'last_message_at', nullable: true })
	public lastMessageAt!: Date | null;

	@Column('int', { name: 'message_count', default: 0 })
	public messageCount!: number;

	@Column('int', { name: 'unread_count', default: 0 })
	public unreadCount!: number;

	// Outcome tracking
	/**
	 * Conversation outcome.
	 * 'meeting_scheduled', 'demo_requested', 'not_interested', 'converted_to_opp', etc.
	 */
	@Column('varchar', { name: 'outcome', length: 50, nullable: true })
	public outcome!: string | null;

	@Column('text', { name: 'outcome_notes', nullable: true })
	public outcomeNotes!: string | null;

	// Relations
	@ManyToOne(() => ReconSocialProfileEntity)
	@JoinColumn({ name: 'social_profile_id' })
	public socialProfile?: ReconSocialProfileEntity;

	@ManyToOne(() => ReconOpportunityEntity)
	@JoinColumn({ name: 'opportunity_id' })
	public opportunity?: ReconOpportunityEntity;
}
